import GlobalHeader from '../../../../components/GlobalHeader.jsx'
import { FaLock, FaLockOpen } from 'react-icons/fa'

export default function EventFormShell({
  currentSection,
  showEventInfo,
  showClientTypes,
  showPackagesTabs,
  showTerms,
  onBack,
  onLogout,
  children,
}) {
  return (
    <div className="event-form-container">
      <GlobalHeader
        title="Event Details"
        subtitle=""
        backTo="/organiser-dash"
        logoutTo="/"
        onBack={onBack}
        onLogout={onLogout}
      />

      <div className="event-form-main">
        <div className="event-form-card">
          {children}
        </div>
      </div>
    </div>
  )
}
